import { debounce } from "lodash";
import { WsEventListener } from "@fidget/common/services/eventsListener";
import { intl } from "@fidget/common/i18n/TypedIntl";
import {
  ChatNotificationParams,
  NotificationType
} from "@fidget/common/models/mst/ui/ChatNotificationStore";
import { IUiStore } from "./UiStore";
import { config } from "@fidget/common/config/config";

export class UiEventListener implements WsEventListener {
  constructor(private _uiFinder: () => IUiStore, public name: string) {}

  get uiStore(): IUiStore {
    return this._uiFinder();
  }

  disconnected() {
    const currentError = this.uiStore.chatNotification;
    if (!currentError || currentError.type !== NotificationType.NoConnection) {
      this.debouncedSetNotification({
        message: intl.formatMessage("widget.error.noConnection"),
        type: NotificationType.NoConnection,
        isDismissDisabled: true
      });
    }
  }

  connected() {
    this.uiStore.removeChatNotificationIfType(NotificationType.NoConnection);
  }

  private debouncedSetNotification = debounce((error: ChatNotificationParams) => {
    this.uiStore.setChatNotification(error);
  }, config.services.times.disconnectNotificationDebounce);
}
